// extracted by mini-css-extract-plugin
export default {"root":"FeaturedEducators_root__bVL+T","listingsHolder":"FeaturedEducators_listingsHolder__dbkkL","listingCard":"FeaturedEducators_listingCard__rlv2S"};